import React from "react";
import shortlistImage from "../../images/shortlistpopup.png";
import rejectImage from "../../images/Rejectpopup.png";
import styles from "./ShortlistPopup.module.scss";
import Modal from "../Modal/Modal";

const ShortlistPopup = ({
  isModalOpen,
  setIsModalOpen,
  handleModalNo,
  handleShortListModalYes,
  handleRejectModalYes,
}) => {
  return (
    <>
      {isModalOpen === "shortList" && (
        <Modal
          onClose={() => setIsModalOpen(false)}
          heading=""
          modalOpen={isModalOpen}
        >
          <section className={styles.Listpopup}>
            <img src={shortlistImage} alt="shortlistImage" />
            <div className={styles.popupListDetails}>
              <p>Shortlist Application </p>
              <p>
                Are you sure? <br /> you want to shortlist the application
              </p>
              <div className={styles.btnSection}>
                <button onClick={handleModalNo} className={styles.cancel}>
                  Cancel
                </button>
                <button
                  onClick={handleShortListModalYes}
                  className={styles.shortlist}
                >
                  Shortlist
                </button>
              </div>
            </div>
          </section>
        </Modal>
      )}

      {isModalOpen === "reject" && (
        <Modal
          onClose={() => setIsModalOpen(false)}
          heading=""
          modalOpen={isModalOpen}
        >
          <section className={styles.Listpopup}>
            <img src={rejectImage} alt="shortlistImage" />
            <div className={styles.popupListDetails}>
              <p>Reject Application </p>
              <p>
                Are you sure? <br /> you want to reject the application
              </p>
              <div className={styles.btnSection}>
                <button onClick={handleModalNo} className={styles.cancel}>
                  Cancel
                </button>
                <button
                  onClick={handleRejectModalYes}
                  className={styles.reject}
                >
                  Reject
                </button>
              </div>
            </div>
          </section>
        </Modal>
      )}
    </>
  );
};

export default ShortlistPopup;
